export const MINUTES_IN_SECONDS = 60;
export const HOUR_IN_SECONDS = 60 * MINUTES_IN_SECONDS;
export const DAY_IN_SECONDS = 24 * HOUR_IN_SECONDS;

export const VAT_PERCENTAGE = 19;